<template>
  <div>
    <b-input
      v-model="recommendation.topic"
      :error-messages="getErrorMessages(v$.topic)"
      label="Назва"
      placeholder="Коротка назва рекомендації"
      @blur="v$.topic.$touch()"></b-input>

    <b-textarea
      v-model="recommendation.description"
      :error-messages="getErrorMessages(v$.description)"
      label="Опис"
      placeholder="Детально опишіть що необхідно зробити для усунення недоліку..."
      rows="2"
      @blur="v$.description.$touch()"></b-textarea>

    <v-row>
      <v-col cols="6">
        <b-server-autocomplete
          v-model="recommendation.executorId"
          :error-messages="getErrorMessages(v$.executorId)"
          :url="urlAllUsers()"
          item-title="name"
          item-value="id"
          label="Виконавець"
          placeholder="Введіть мін. 3 символи"
          @blur="v$.executorId.$touch()">
        </b-server-autocomplete>
      </v-col>
      <v-col cols="6">
        <b-input-date
          v-model="recommendation.deadline"
          :error-messages="getErrorMessages(v$.deadline)"
          label="Термін виконання"
          time-picker
          @blur="v$.deadline.$touch()"></b-input-date>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import { PropType, reactive } from 'vue'
import { Dialog } from '@/dialog'
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import { urlAllUsers } from '@/utils/urls'
import { getErrorMessages } from 'best-modules/utils'
import { fillDirectory } from '@/directory'
import {
  BInputDate,
  BServerAutocomplete,
  BTextarea,
} from 'best-modules/components/index'
import { auditRecommendationCreate } from '@/requests/audit'

export default {
  name: 'AuditRecommendation',
  components: {
    BInputDate,
    BServerAutocomplete,
    BTextarea,
  },
  props: {
    dialog: {
      type: Object as PropType<Dialog>,
      required: true,
    },
  },
  methods: { urlAllUsers, getErrorMessages },
  setup(props) {
    const recommendation = reactive({
      auditFlawId: props.dialog.dialogData.auditFlawId,
      topic: null as any,
      executorId: null as any,
      deadline: null as any,
      description: null as any,
    })

    const rules = {
      topic: { required },
      executorId: { required },
      deadline: { required },
      description: { required },
    }
    const v$ = useVuelidate(rules, recommendation)

    const submit = () => {
      return auditRecommendationCreate(recommendation).then(res => {
        return res
      })
    }

    fillDirectory(['userList'])

    return {
      recommendation,
      v$,
      submit,
    }
  },
}
</script>

<style lang="scss" scoped></style>
